import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item1Props {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item1: React.FC<Item1Props> = ({ required = false, propertyGuid, isReview = false }) => {
    const [item1, set_item1] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #1']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #1': [b.values?.['Expand Primary Structure']?.['Item #1']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Item #1';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(item1)}
                />
            ) : (
                <MoneyBox
                    id={'item1'}
                    allowNegative={false}
                    value={item1}
                    onChange={(value) => set_item1(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
